var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.322 6h-6.6l1.6-4.7c.3-1-.9-1.8-1.7-1l-8 8c-.6.6-.2 1.7.7 1.7h6.6l-1.6 4.7c-.3 1 .9 1.8 1.7 1l8-8c.6-.6.2-1.7-.7-1.7Z",
    fill: "current"
  })));
};
export default SvgLightning;